import React, { useEffect, useState } from 'react';
import './ThemeToggle.css';
import { FaMoon, FaSun } from 'react-icons/fa';

const getInitialTheme = () => {
  if (typeof window === 'undefined') {
    return 'dark';
  }

  return localStorage.getItem('portfolio-theme') || 'dark';
};

const ThemeToggle = () => {
  const [theme, setTheme] = useState(getInitialTheme);

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem('portfolio-theme', theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme((currentTheme) => (currentTheme === 'dark' ? 'light' : 'dark'));
  };

  const isDark = theme === 'dark';

  return (
    <button
      type="button"
      className="theme-toggle"
      onClick={toggleTheme}
      aria-label={`Switch to ${isDark ? 'light' : 'dark'} mode`}
    >
      <span className="theme-toggle__icon">{isDark ? <FaSun /> : <FaMoon />}</span>
      <span className="theme-toggle__label">{isDark ? 'Light mode' : 'Dark mode'}</span>
    </button>
  );
};

export default ThemeToggle;
